import React, { useState } from 'react';
import PageWrapper from '../components/PageWrapper';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Admin = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [pass, setPass] = useState('');
  const [activeTab, setActiveTab] = useState('bewerber');

  // Dummy Daten für Demo
  const stats = [
    { label: 'Neue Bewerber', val: '12', icon: FiIcons.FiUsers, color: 'text-blue-600' },
    { label: 'Offene Jobs', val: '8', icon: FiIcons.FiBriefcase, color: 'text-cyan-600' },
    { label: 'Firmenanfragen', val: '4', icon: FiIcons.FiHome, color: 'text-purple-600' },
  ];

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4">
        <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
          <h1 className="text-2xl font-bold text-center mb-6 text-blue-900">Nordblick Admin-Login</h1>
          <input 
            type="password" 
            placeholder="Passwort eingeben..." 
            className="w-full p-3 border rounded-lg mb-4"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
          />
          <button 
            onClick={() => pass === 'nordblick2024' ? setIsLoggedIn(true) : alert('Falsch!')}
            className="w-full bg-blue-900 text-white py-3 rounded-lg font-bold"
          >
            Einloggen
          </button>
          <p className="text-[10px] text-center text-slate-400 mt-4 uppercase tracking-widest">(Demo-Passwort: nordblick2024)</p>
        </div>
      </div>
    );
  }

  return (
    <PageWrapper className="bg-slate-100 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-blue-900">Verwaltungs-Dashboard</h1>
          <button onClick={() => setIsLoggedIn(false)} className="text-slate-500 hover:text-red-500 flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiLogOut} /> Abmelden
          </button>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {stats.map((s, i) => (
            <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 flex items-center gap-4">
              <div className={`p-4 rounded-xl bg-slate-50 ${s.color}`}>
                <SafeIcon icon={s.icon} className="h-8 w-8" />
              </div>
              <div>
                <p className="text-sm text-slate-500 font-medium">{s.label}</p>
                <p className="text-3xl font-bold text-slate-900">{s.val}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className="flex gap-4 mb-6">
          {['bewerber', 'arbeitgeber', 'stellen'].map(tab => (
            <button 
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-2 rounded-full font-bold capitalize transition-all ${activeTab === tab ? 'bg-blue-900 text-white' : 'bg-white text-slate-500'}`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Content Table */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-slate-50 border-b border-slate-100">
              <tr>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase">Name / Titel</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase">Details</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase">Status</th>
                <th className="p-4 text-xs font-bold text-slate-400 uppercase text-right">Aktionen</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {/* Demo Row */}
              <tr className="hover:bg-slate-50 transition-colors">
                <td className="p-4">
                  <div className="font-bold text-blue-900">Max Mustermann</div>
                  <div className="text-xs text-slate-500">Industriemechaniker</div>
                </td>
                <td className="p-4">
                  <div className="text-sm">AVGS: Ja | B1 Deutsch</div>
                </td>
                <td className="p-4">
                  <span className="px-2 py-1 bg-yellow-100 text-yellow-700 text-[10px] font-bold rounded-full uppercase">In Prüfung</span>
                </td>
                <td className="p-4 text-right">
                  <div className="flex justify-end gap-2">
                    <button className="p-2 text-slate-400 hover:text-cyan-600"><SafeIcon icon={FiIcons.FiDownload} /></button>
                    <button className="p-2 text-slate-400 hover:text-blue-900"><SafeIcon icon={FiIcons.FiEdit} /></button>
                    <button className="p-2 text-slate-400 hover:text-red-500"><SafeIcon icon={FiIcons.FiTrash2} /></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Admin;